export default function FilterBox({ title, icon, children }) {
	return (
		<div class="text-sm">
			<p class="font-display font-bold mb-2.5">
				{icon && <i class={`far fa-${icon} mr-1.5`}></i>}
				{title}
			</p>
			{children}
		</div>
	);
}
